import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";

function TermsOfService() {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/*<div className="mb-8">
        <Link to="/register">
          <Button variant="outline" size="sm">
            {t("back_to_registration") || "Back to Registration"}
          </Button>
        </Link>
      </div>*/}

      <div className="prose prose-slate max-w-none">
        <h1 className="text-3xl font-bold mb-6">{t("terms_of_service") || "Terms of Service"}</h1>

        <p className="text-sm text-gray-600 mb-6">
          {t("last_updated") || "Last Updated"}: {new Date().toLocaleDateString()}
        </p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. {t("acceptance_of_terms") || "Acceptance of Terms"}</h2>
          <p className="mb-4">
            By accessing and using this application, you accept and agree to be bound by the terms and provision of this agreement.
            If you do not agree to these Terms of Service, please do not use our service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. {t("use_license") || "Use License"}</h2>
          <p className="mb-4">
            Permission is granted to temporarily access the materials (information or software) on this application for personal,
            non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose, or for any public display (commercial or non-commercial)</li>
            <li>Attempt to decompile or reverse engineer any software contained in the application</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
            <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. {t("user_accounts") || "User Accounts"}</h2>
          <p className="mb-4">
            When you create an account with us, you must provide information that is accurate, complete, and current at all times.
            Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account.
          </p>
          <p className="mb-4">
            You are responsible for safeguarding the password that you use to access the service and for any activities or actions
            under your password, whether your password is with our service or a third-party service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">4. {t("user_content") || "User Content"}</h2>
          <p className="mb-4">
            Our service allows you to create, upload, store, and share content. You retain ownership of any intellectual property
            rights that you hold in that content. When you upload or otherwise submit content to our service, you give us (and those
            we work with) a worldwide license to use, host, store, reproduce, modify, and distribute your content.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">5. {t("prohibited_uses") || "Prohibited Uses"}</h2>
          <p className="mb-4">
            You may not use our service:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>For any unlawful purpose or to solicit others to perform or participate in any unlawful acts</li>
            <li>To violate any international, federal, provincial or state regulations, rules, laws, or local ordinances</li>
            <li>To infringe upon or violate our intellectual property rights or the intellectual property rights of others</li>
            <li>To harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate</li>
            <li>To submit false or misleading information</li>
            <li>To upload or transmit viruses or any other type of malicious code</li>
            <li>To spam, phish, pharm, pretext, spider, crawl, or scrape</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">6. {t("termination") || "Termination"}</h2>
          <p className="mb-4">
            We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever,
            including without limitation if you breach the Terms. Upon termination, your right to use the service will immediately cease.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">7. {t("limitation_of_liability") || "Limitation of Liability"}</h2>
          <p className="mb-4">
            In no event shall the application or its suppliers be liable for any damages (including, without limitation, damages for
            loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on the
            application, even if the application or an authorized representative has been notified orally or in writing of the
            possibility of such damage.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">8. {t("changes_to_terms") || "Changes to Terms"}</h2>
          <p className="mb-4">
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material,
            we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change
            will be determined at our sole discretion.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">9. {t("contact_us") || "Contact Us"}</h2>
          <p className="mb-4">
            If you have any questions about these Terms of Service, please contact us through our support channels.
          </p>
        </section>
      </div>
    </div>
  );
}

export default TermsOfService;
